import { namedStateMapProvider } from "./namedState";

/**
 * Statemapper to retrieve the currently selected tab in the application
 * @param {*} state 
 */
export const activeTabState = namedStateMapProvider( 'activeTab' );